module.exports = __webpack_public_path__ + "static/media/holy-cross.361c45c7.png";